import React from 'react'
import PropType from 'prop-types'
import MenuItem from '@material-ui/core/MenuItem'
import uuid from 'uuid/v4'

const MenuItemAdapter = ({ children, className, onClick }) => (
  <MenuItem className={className} onClick={onClick} key={uuid()}>{ children }</MenuItem>
)

MenuItemAdapter.defaultProps = {
  className: '',
  onClick: () => null,
}

MenuItemAdapter.propTypes = {
  children: PropType.node.isRequired,
  className: PropType.string,
  onClick: PropType.func,
}

export default MenuItemAdapter
